
export class IssueDevelop {
    id: number;
    description: string;
    //statuses are 0 -started, 1 - not started, 2 - finished
    status: number;
    date: string;
  }
  